(function ($, Drupal) {
  Drupal.behaviors.bbvideoCardV1 = {
    attach: function (context, settings) {
      var $cards = $('.js-mantle-video-card', context);

      $cards.each(function (i, obj) {
        var $card = $(obj);
      });
    }
  };
})(jQuery, Drupal);
